<template>
  <card :item="item" :type="type">
    <div class="cardbody" @click.stop="goDetails(item)">
      <div class="header color3">
        <div class="header-title single_hide color3">{{ item.name }}</div>
      </div>
      <div class="content">
        <div class="item_tag">
          <span class="tagItem" v-if="item.teamSize">
            团队人数：{{ item.teamSize.toString().includes('人') ? item.teamSize  :  item.teamSize ? item.teamSize +'人' :  '/'}}
          </span> 
          <span class="tagItem" v-if="item.contact">
            负责人：{{ item.contact }}
          </span>
        </div>
        <el-row >
          <el-col :span="24" class="item_text single_hide">
            <span class="color6">找活工队:</span>
            <span class="color3">{{
              item.teamName | formattingEngineering
            }}</span>
          </el-col>
          <el-col :span="24" class="item_text single_hide">
            <span class="color6">工程专业:</span>
            <span class="color3">{{
              item.categoryName || "/"
            }}</span>
          </el-col>
          <el-col :span="19" class="item_text single_hide">
            <span class="color6">工作区域:</span>
            <span class="color3">{{
              item.serviceAreaName | formattingEngineering
            }}</span>
          </el-col>
          <el-col :span="5" class=" createTime">
            <span v-if="item.updateTime===item.createTime" class="color6">{{item.createTime | formatDate}}发布</span>
            <span v-else class="color6">{{item.updateTime | formatDate}}更新</span>
          </el-col>
        </el-row>
      </div>
    </div>
  </card>
</template>

<script>
import { checkDataStatusMessage } from "@/utils/checkDataStatus"
export default {
  name: "cardTeamSearchJob",
  components: {
    card: () => import("@/components/card/card")
  },
  inject: ["cardListCom"],
  data() {
    return {}
  },
  props: {
    item: Object,
    type: Number, // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工 7工队找活
  },
  methods: {
    //跳转详细
    async goDetails(item) {
      let type = await checkDataStatusMessage.call(this, this.type, item.no)
      if (type != 1) {
        return
      }
      let routeUrlC = `${"/TeamSearchJobDetail"}?no=${item.no}`
      window.open(routeUrlC, "_blank")
    }
  },
}
</script>

<style lang="scss" scoped>
.createTime{
      text-align: right;
      margin-top: 10px;
      padding-right: 5px;
  }
.cardbody {
  cursor: pointer;
  .header {
    padding-left:10px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
    height: 34px;
    line-height: 34px;
    .header-title {
      max-width: 550px;
      font-size: 16px;
      margin-right: 10px;
    }
  }
  .content {
    padding: 10px;
    .item_tag {
      display: flex;
      .tagItem {
        height: 24px;
        line-height: 24px;
        background: rgba(2, 134, 223, 0.1);
        color: #0286df;
        font-size: 12px;
        margin-right: 10px;
        padding: 0 5px;
      }
    }
    .item_text {
      margin-top: 10px;
    }
  }
}
.single_hide {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
div {
  box-sizing: border-box;
}
.color6 {
  color: #666666;
}
.color3 {
  color: #333333;
}
</style>